/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_File_Invalid_Characters_DescriptionInputs */

const en_toast_file_invalid_characters_description = /** @type {(inputs: Toast_File_Invalid_Characters_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allowed characters: letters (a-z, A-Z), numbers (0-9), dots, hyphens, underscores, and spaces. Special characters like í, ä, ë, ñ, ü are not supported.`)
};

const nl_toast_file_invalid_characters_description = /** @type {(inputs: Toast_File_Invalid_Characters_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toegestane tekens: letters (a-z, A-Z), cijfers (0-9), punten, koppeltekens, underscores en spaties. Speciale tekens zoals í, ä, ë, ñ, ü worden niet ondersteund.`)
};

/**
* | output |
* | --- |
* | "Allowed characters: letters (a-z, A-Z), numbers (0-9), dots, hyphens, underscores, and spaces. Special characters like í, ä, ë, ñ, ü are not supported." |
*
* @param {Toast_File_Invalid_Characters_DescriptionInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const toast_file_invalid_characters_description = /** @type {((inputs?: Toast_File_Invalid_Characters_DescriptionInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_File_Invalid_Characters_DescriptionInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_toast_file_invalid_characters_description(inputs)
	return en_toast_file_invalid_characters_description(inputs)
});